var map = {
	"./data_composite": "8Iiw",
	"./data_composite.js": "8Iiw",
	"./data_registered": "mp2H",
	"./data_registered.js": "mp2H",
	"./data_unregistered": "KrTf",
	"./data_unregistered.js": "KrTf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ugeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newreports/data_config ^\.\/.*$
// module id = ugeg
// module chunks = 4